import React, {useEffect, useState} from "react";
import PanelAddBalanceRequest from "../../../UI/AddBalanceRequests/add";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import AddOrderForm from "../../../UI/Orders/add";
import PanelBody from "../../../UI/Panel/PanelBody";
import PanelHead from "../../../UI/Panel/PanelHead";

const AddBalanceRequest = () => {
    const [isPanelsLoading, setIsPanelsLoading] = useState(true);
    const [isUsersLoading, setUsersLoading] = useState(true);
    const [panels, setPanels] = useState([]);
    const [users, setUsers] = useState([]);

    const getPanels = async () => {
        setIsPanelsLoading(true);
        const { response } = await Helper.Get({
            url: api_Routes.Groups.PanelViewByReseller,
            hasToken: true,
        });
        if (response) {
            setPanels(response);
        }
        setIsPanelsLoading(false);
    };

    const getUsers = async () => {
        setUsersLoading(true);
        const { response, message } = await Helper.Get({
            url: `${api_Routes.Users.ViewAllByReseller}`,
            hasToken: true,
        });
        if (response) {
            setUsers(response?.data);
        }
        setUsersLoading(false);
    };

    useEffect(() => {
        getPanels();
        getUsers();
    }, []);
  return (
    <div>
        <PanelHead title="Add Balance Request" />
        <PanelBody
            content={
                <PanelAddBalanceRequest
                    panels={panels}
                    isPanelsLoading={isPanelsLoading}
                    users={users}
                    isUsersLoading={isUsersLoading}
                />
            }
        />
    </div>
  );
};

export default AddBalanceRequest;
